import React, { Component } from 'react'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

class RedirectPage extends Component {
    render() {
      
        return (
            <Redirect to="/" />
        )
    }
}
export default RedirectPage;